import React, { useEffect, useState } from "react";
import { Stack } from "@mui/system";
import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import ListAltIcon from '@mui/icons-material/ListAlt';
import { createTheme, ThemeProvider } from '@mui/material/styles';

export default function Notification(props) {

  const theme = createTheme({
    palette: {
      primary: {
        main: '#5cb500',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Stack direction="row" spacing={2} alignContent="center" alignItems="center" justifyContent="space-between" sx={{ width: "100% !important" }}>
        <ListAltIcon /> 
        <Typography variant="body2" sx={{ flex: 1, fontWeight: 'bold', fontSize: 14, marginRight: 20 }}>
          {props.descrizione}
        </Typography>
        <Button size="small" variant="contained" color="primary" sx={{ color: "#ffffff" }} onClick={() => props.onReminderDone({ tipo: props.tipo, id: props.id, id_tipo: props.id_tipo })}>
          {props.tipo === "commessa_in" ? "Ricevuto" : (props.tipo === 'ordine' || props.tipo === 'notifica ordine' || props.tipo === 'cliente' || props.tipo === 'prodotto' || props.tipo === 'notifica ddt' || props.tipo === 'notifica ddt amministrazione') ? "Visualizza" : "Fatto"}
        </Button>
        {
          (props.tipo === "commessa_in" || props.tipo === "fattura") && (
            <Button size="small" variant="contained" color="primary" sx={{ color: "#ffffff" }} onClick={() => {
              let x = {
                show: true,
                tipo: props.tipo,
                id: props.id_tipo,
                data_scadenza: props.data_scadenza,
                idReminder: props.id
              }
              props.onPosponi(x);
            }}>
              Posponi
            </Button>
          )
        }
      </Stack>
    </ThemeProvider>
  )
}